import React, { Component, StrictMode, useEffect } from "react";
import ReactDOM from 'react-dom/client';
import { useSelector, useDispatch } from "react-redux";

const Badge = () => {

  const unreaded = useSelector(state => state.launcher.unreaded);

  if (!unreaded) {
    return <></>;
  }

  return (
    <div className="kil-chat-badge">
      {unreaded >= 9 &&
        <>
        9+
        </>
      }
      {unreaded < 9 &&
        unreaded
      }
    </div>
  );
}

export default Badge;